
import { FC } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface CallToActionProps {
  whatsappLink: string;
}

export const CallToAction: FC<CallToActionProps> = ({ whatsappLink }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.6 }}
      className="text-center"
    >
      <p className="text-gray-700 dark:text-gray-300 mb-6 text-lg font-medium">
        Download the app today and take the first step toward better sleep for your family!
      </p>
      <div className="flex justify-center">
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="inline-block"
        >
          <Link to="/">
            <Button size="lg" variant="outline" className="border-indigo-400 dark:border-indigo-600 text-indigo-700 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/50">
              <ArrowLeft className="mr-2" size={16} />
              Back to Home
            </Button>
          </Link>
        </motion.div>
      </div>
    </motion.div>
  );
};
